import {
  GET_CURRENT_USER_REQUEST,
  NO_CURRENT_USER,
  GET_CURRENT_USER_SUCCESS,
  GET_CURRENT_USER_FAILURE,
  CURRENT_USER_ALREADY_SET,
  UPDATE_USER_REQUEST,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAILURE,
  CLEAR_CURRENT_USER_STATUS,
  CURRENT_USER_REGISTRATION_COMPLETE,
  UPDATE_APPRAISER_REQUEST,
  UPDATE_APPRAISER_SUCCESS,
  UPDATE_APPRAISER_FAILURE,
  CHANGE_PASSWORD_REQUEST,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_FAILURE,
  UNSET_CURRENT_USER,
  CREATE_CLIENT_REQUEST,
  CREATE_CLIENT_SUCCESS,
  CREATE_CLIENT_FAILURE,
  UPDATE_CLIENT_REQUEST,
  UPDATE_CLIENT_SUCCESS,
  UPDATE_CLIENT_FAILURE,
  DELETE_CLIENT_REQUEST,
  DELETE_CLIENT_SUCCESS,
  DELETE_CLIENT_FAILURE,
  CREATE_COMMENT_REQUEST,
  CREATE_COMMENT_SUCCESS,
  CREATE_COMMENT_FAILURE,
  UPDATE_COMMENT_REQUEST,
  UPDATE_COMMENT_SUCCESS,
  UPDATE_COMMENT_FAILURE,
  DELETE_COMMENT_REQUEST,
  DELETE_COMMENT_SUCCESS,
  DELETE_COMMENT_FAILURE,
  CHANGE_USER_DOCS_REQUEST,
  CHANGE_USER_DOCS_SUCCESS,
  CREATE_COMPANY_INVITATIONS_REQUEST,
  CREATE_COMPANY_INVITATIONS_SUCCESS,
  CREATE_COMPANY_INVITATIONS_FALURE,
  DELETE_COMPANY_INVITATIONS_REQUEST,
  DELETE_COMPANY_INVITATIONS_SUCCESS,
  DELETE_COMPANY_INVITATIONS_FALURE,
  RESEND_COMPANY_INVITATIONS_REQUEST,
  RESEND_COMPANY_INVITATIONS_FAILURE,
  RESEND_COMPANY_INVITATIONS_SUCCESS,
  CHANGE_USER_ROLE,
  GET_NOTIFICATIONS_SUCCESS,
  RECEIVE_NOTIFICATIONS,
  VIEW_NOTIFICATIONS,
  GET_INVITATIONS_SUCCESS,
  UPDATE_INVITATIONS_REQUEST,
  UPDATE_INVITATIONS_SUCCESS,
  UPDATE_INVITATIONS_FAILURE,
  SEND_BOX_NOTIFICATION,
  CLEAR_BOX_NOTIFICATION,
  CLEAR_ALL_BOX_NOTIFICATIONS,
  UPDATE_COMPANY_REQUEST,
  UPDATE_COMPANY_SUCCESS,
  UPDATE_COMPANY_FAILURE,
  UPDATE_USER_COMPANY_ROLE_REQUEST,
  UPDATE_USER_COMPANY_ROLE_SUCCESS,
  UPDATE_USER_COMPANY_ROLE_FAILURE,
  REMOVE_USER_FROM_COMPANY_REQUEST,
  REMOVE_USER_FROM_COMPANY_SUCCESS,
  REMOVE_USER_FROM_COMPANY_FAILURE,
  GET_COMPANY_APPRAISERS_REQUEST,
  GET_COMPANY_APPRAISERS_SUCCESS,
  GET_COMPANY_APPRAISERS_FAILURE,
  UPDATE_COMPANY_CLIENT_REQUEST,
  UPDATE_COMPANY_CLIENT_SUCCESS,
  UPDATE_COMPANY_CLIENT_FAILURE,
  CREATE_COMPANY_CLIENT_REQUEST,
  CREATE_COMPANY_CLIENT_SUCCESS,
  CREATE_COMPANY_CLIENT_FAILURE,
  EDIT_COMPANY_CLIENT_TAGS_REQUEST,
  EDIT_COMPANY_CLIENT_TAGS_SUCCESS,
  EDIT_COMPANY_CLIENT_TAGS_FAILURE,
  VERIFY_INVITATION_EMAILS_REQUEST,
  VERIFY_INVITATION_EMAILS_SUCCESS,
  VERIFY_INVITATION_EMAILS_FAILURE,
  SUBMIT_UPDATED_CONSENT_REQUEST,
  SUBMIT_UPDATED_CONSENT_SUCCESS,
  SUBMIT_UPDATED_CONSENT_FAILURE,
  VERIFY_APPRAISER_REQUEST,
  VERIFY_APPRAISER_SUCCESS,
  VERIFY_APPRAISER_FAILURE,
  UPDATE_APPRAISER_COVERAGE_REQUEST,
  UPDATE_APPRAISER_COVERAGE_SUCCESS,
  UPDATE_APPRAISER_COVERAGE_FAILURE,
  GET_APPRAISERS_COVERAGE_REQUEST,
  GET_APPRAISERS_COVERAGE_SUCCESS,
  GET_APPRAISERS_COVERAGE_FAILURE,
  UPLOAD_COMPANY_EO_REQUEST,
  UPLOAD_COMPANY_EO_SUCCESS,
  UPLOAD_COMPANY_EO_FAILURE,
  GET_COMPANY_SUCCESS,
} from '../constants/actionTypes'

const initialState = {
  currentUser: {},
  box_notifications: [],
  notifications: [],
  invitations: [],
  isFetching: false,
  isChanging: false,
  isUpdatingDocs: false,
  isUpdating: false,
  isCreatingClient: false,
  isUpdatingClient: false,
  isDeletingClient: false,
  isUpdatingInvitations: false,
  isCreatingInvitation: false,
  inDeletingInvitation: false,
  isUpdatingCompany: false,
  isUpdatingCompanyUser: false,
  isRemovingUserFromCompany: false,
  companyAppraisers: [],
  companyAppraisersCount: 0,
  isFetchingCompanyAppraisers: false,
  isCreatingCompanyClient: false,
  isVerifyingEmails: false,
  verifyEmailSuccess: false,
  invitationEmailErrors: {},
  invitedEmailErrors: {},
  isSubmittingConsent: false,
  isVerifyingAppraiser: false,
  status: null,
}

function currentUserReducer(state = initialState, action) {
  switch (action.type) {
    case GET_CURRENT_USER_REQUEST:
      return {
        ...state,
        isFetching: action.isFetching,
        errorMessage: '',
        status: action.status,
      }
    case NO_CURRENT_USER:
      return {
        ...state,
        isFetching: action.isFetching,
        currentUser: action.currentUser,
        status: action.status,
      }
    case GET_CURRENT_USER_SUCCESS:
      return {
        ...state,
        isFetching: action.isFetching,
        message: action.message,
        status: action.status,
        currentUser: { ...state.currentUser, ...action.currentUser },
      }
    case GET_CURRENT_USER_FAILURE:
      return {
        ...state,
        isFetching: action.isFetching,
        errorMessage: action.message,
        status: action.status,
      }
    case CURRENT_USER_ALREADY_SET:
      return {
        ...state,
        isFetching: action.isFetching,
        status: action.status,
      }
    case CURRENT_USER_REGISTRATION_COMPLETE:
      return {
        ...state,
        registrationComplete: true,
      }
    case CHANGE_USER_ROLE:
      return {
        ...state,
        currentUser: { ...state.currentUser, role: action.role },
      }
    case GET_INVITATIONS_SUCCESS:
      return {
        ...state,
        invitations: action.invitations,
      }
    case GET_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        notifications: action.notifications,
        invitations: action.invitations,
      }
    case RECEIVE_NOTIFICATIONS: {
      const stateUpdate = {}
      if (action.invitations) {
        stateUpdate.currentUser = { ...state.currentUser, invitations: action.invitations }
      }
      if (action.notifications) {
        stateUpdate.notifications = action.notifications
      }
      return {
        ...state,
        ...stateUpdate,
      }
    }
    case VIEW_NOTIFICATIONS:
      return {
        ...state,
        notifications: action.notifications,
      }
    case UPDATE_INVITATIONS_REQUEST:
      return {
        ...state,
        isUpdatingInvitations: action.isUpdating,
        errorMessage: '',
      }
    case UPDATE_INVITATIONS_SUCCESS:
      return {
        ...state,
        isUpdatingInvitations: action.isUpdating,
        currentUser: action.currentUser,
      }
    case UPDATE_INVITATIONS_FAILURE:
      return {
        ...state,
        isUpdatingInvitations: action.isUpdating,
        errorMessage: action.message,
      }
    case SEND_BOX_NOTIFICATION:
      return {
        ...state,
        box_notifications: [...state.box_notifications, action.notification],
      }
    case CLEAR_BOX_NOTIFICATION:
      return {
        ...state,
        box_notifications: state.box_notifications.filter(notification => notification.id !== action.id),
      }
    case CLEAR_ALL_BOX_NOTIFICATIONS:
      return {
        ...state,
        box_notifications: [],
      }
    case CLEAR_CURRENT_USER_STATUS:
      return {
        ...state,
        status: action.status,
      }
    case UPDATE_USER_REQUEST:
      return {
        ...state,
        isUpdating: action.isUpdating,
        errorMessage: '',
        status: action.status,
      }
    case UPDATE_USER_SUCCESS:
      return {
        ...state,
        isUpdating: action.isUpdating,
        currentUser: action.userUpdates,
        status: action.status,
      }
    case UPDATE_USER_FAILURE:
      return {
        ...state,
        isUpdating: action.isUpdating,
        errorMessage: action.message,
        status: action.status,
      }
    case UPDATE_APPRAISER_REQUEST:
      return {
        ...state,
        isUpdating: action.isUpdating,
        errorMessage: '',
        appraiserUpdateStatus: action.status,

      }
    case UPDATE_APPRAISER_SUCCESS: {
      let appraiser_idx = 0
      const companyAppraisers = [...state.companyAppraisers]
      state.companyAppraisers.forEach((appraiser, idx) => {
        if (appraiser.id === action.userUpdates.id) { appraiser_idx = idx }
      })
      companyAppraisers[appraiser_idx] = {
        ...companyAppraisers[appraiser_idx],
        ...action.userUpdates,
      }
      return {
        ...state,
        isUpdating: action.isUpdating,
        companyAppraisers: companyAppraisers,
        appraiserUpdateStatus: action.status,
      }
    }
    case UPDATE_APPRAISER_FAILURE:
      return {
        ...state,
        isUpdating: action.isUpdating,
        errorMessage: action.message,
        appraiserUpdateStatus: action.status,
      }
    case CHANGE_PASSWORD_REQUEST:
      return {
        ...state,
        isChanging: action.isChanging,
        errorMessage: '',
      }
    case CHANGE_PASSWORD_SUCCESS:
      return {
        ...state,
        isChanging: action.isChanging,
      }
    case CHANGE_PASSWORD_FAILURE:
      return {
        ...state,
        isChanging: action.isChanging,
        errorMessage: action.message,
      }
    case UNSET_CURRENT_USER:
      return {
        ...state,
        currentUser: {},
      }
    case CREATE_CLIENT_REQUEST:
      return {
        ...state,
        isCreatingClient: action.isCreatingClient,
        errorMessage: '',
      }
    case CREATE_CLIENT_SUCCESS: {
      const currentUser = { ...state.currentUser }
      currentUser.clients.push(action.client)
      return {
        ...state,
        currentUser,
        isCreatingClient: action.isCreatingClient,
      }
    }
    case CREATE_CLIENT_FAILURE:
      return {
        ...state,
        isCreatingClient: action.isCreatingClient,
        errorMessage: action.message,
      }
    case CREATE_COMMENT_REQUEST:
      return {
        ...state,
        isCreatingComment: action.isCreatingComment,
      }
    case CREATE_COMMENT_SUCCESS:
      return {
        ...state,
        isCreatingComment: action.isCreatingComment,
        currentUser: { ...state.currentUser, ...action.currentUser },
      }
    case CREATE_COMMENT_FAILURE:
      return {
        ...state,
        isCreatingComment: action.isCreatingComment,
        errorMessage: action.message,
      }
    case UPDATE_COMMENT_REQUEST:
      return {
        ...state,
        isUpdatingComment: action.isUpdatingComment,
      }
    case UPDATE_COMMENT_SUCCESS:
      return {
        ...state,
        isUpdatingComment: action.isUpdatingComment,
        currentUser: { ...state.currentUser, ...action.currentUser },
      }
    case UPDATE_COMMENT_FAILURE:
      return {
        ...state,
        isUpdatingComment: action.isUpdatingComment,
        errorMessage: action.message,
      }
    case DELETE_COMMENT_REQUEST:
      return {
        ...state,
        isDeletingComment: action.isDeletingComment,
      }
    case DELETE_COMMENT_SUCCESS:
      return {
        ...state,
        isDeletingComment: action.isDeletingComment,
        currentUser: { ...state.currentUser, ...action.currentUser },
      }
    case DELETE_COMMENT_FAILURE:
      return {
        ...state,
        isDeletingComment: action.isDeletingComment,
        errorMessage: action.message,
      }
    case CHANGE_USER_DOCS_REQUEST:
      return {
        ...state,
        isUpdatingDocs: action.isUpdatingDocs,
      }
    case CHANGE_USER_DOCS_SUCCESS:
      return {
        ...state,
        isUpdatingDocs: action.isUpdatingDocs,
        currentUser: { ...state.currentUser, ...action.currentUser },
      }
    case UPDATE_CLIENT_REQUEST:
      return {
        ...state,
        isUpdatingClient: action.isUpdatingClient,
        errorMessage: '',
      }
    case UPDATE_CLIENT_SUCCESS:
      return {
        ...state,
        isUpdatingClient: action.isUpdatingClient,
        currentUser: { ...state.currentUser, ...action.currentUser },
      }
    case UPDATE_CLIENT_FAILURE:
      return {
        ...state,
        isUpdatingClient: action.isUpdatingClient,
        errorMessage: action.message,
      }
    case DELETE_CLIENT_REQUEST:
      return {
        ...state,
        isDeletingClient: action.isDeletingClient,
        errorMessage: '',
      }
    case DELETE_CLIENT_SUCCESS:
      return {
        ...state,
        isDeletingClient: action.isDeletingClient,
        currentUser: { ...state.currentUser, ...action.currentUser },
      }
    case DELETE_CLIENT_FAILURE:
      return {
        ...state,
        isDeletingClient: action.isDeletingClient,
        errorMessage: action.message,
      }

    case CREATE_COMPANY_INVITATIONS_REQUEST:
      return {
        ...state,
        isCreatingInvitation: action.isCreatingInvitation,
        errorMessage: '',
        invitationStatus: action.invitationStatus,
      }

    case CREATE_COMPANY_INVITATIONS_FALURE:
      return {
        ...state,
        isCreatingInvitation: action.isCreatingInvitation,
        errorMessage: action.message,
        invitationStatus: action.invitationStatus,
      }

    case CREATE_COMPANY_INVITATIONS_SUCCESS: {
      const currentUserObj = { ...action.currentUser }
      const newPendingInvitations = action.invitations.filter(invitation => !invitation.resolved)
      const { company: { pending_invitations: existingPendingInvitations = [] } = {} } = currentUserObj || {}
      currentUserObj.company.pending_invitations = [...existingPendingInvitations, ...newPendingInvitations]

      return {
        ...state,
        isCreatingInvitation: action.isCreatingInvitation,
        currentUser: currentUserObj,
        invitedEmailErrors: action.invitedEmailErrors,
        companyAppraisers: action.companyAppraisers,
        invitationStatus: action.invitationStatus,
      }
    }
    case RESEND_COMPANY_INVITATIONS_REQUEST:
      return {
        ...state,
        isCreatingInvitation: action.isCreatingInvitation,
        errorMessage: '',
        invitationStatus: action.invitationStatus,
      }

    case RESEND_COMPANY_INVITATIONS_FAILURE:
      return {
        ...state,
        isCreatingInvitation: action.isCreatingInvitation,
        errorMessage: action.message,
        invitationStatus: action.invitationStatus,
      }

    case RESEND_COMPANY_INVITATIONS_SUCCESS:
      return {
        ...state,
        isCreatingInvitation: action.isCreatingInvitation,
        invitedEmailErrors: action.invitedEmailErrors,
        invitationStatus: action.invitationStatus,
      }

    case DELETE_COMPANY_INVITATIONS_REQUEST:
      return {
        ...state,
        isDeletingInvitation: action.isDeletingInvitation,
        errorMessage: '',
      }

    case DELETE_COMPANY_INVITATIONS_FALURE:
      return {
        ...state,
        isDeletingInvitation: action.isDeletingInvitation,
        errorMessage: action.message,
      }

    case DELETE_COMPANY_INVITATIONS_SUCCESS:

      return {
        ...state,
        isDeletingInvitation: action.isDeletingInvitation,
        currentUser: action.currentUser,
      }
    case UPDATE_COMPANY_REQUEST:
      return {
        ...state,
        isUpdatingCompany: action.isUpdatingCompany,
        errorMessage: '',
        status: action.status,
      }
    case UPDATE_COMPANY_SUCCESS:
      return {
        ...state,
        isUpdatingCompany: action.isUpdatingCompany,
        currentUser: {
          ...state.currentUser,
          company: action.company,
        },
        status: action.status,
      }
    case UPDATE_COMPANY_FAILURE:
      return {
        ...state,
        isUpdatingCompany: action.isUpdatingCompany,
        errorMessage: action.message,
        status: action.status,
      }
    case UPLOAD_COMPANY_EO_REQUEST:
      return {
        ...state,
        eoStatus: action.status,
        errorMessage: '',
      }
    case UPLOAD_COMPANY_EO_SUCCESS:
      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          company: action.company,
        },
        eoStatus: action.status,
      }
    case UPLOAD_COMPANY_EO_FAILURE:
      return {
        ...state,
        eoStatus: action.status,
        errorMessage: action.message,
      }
    case GET_APPRAISERS_COVERAGE_REQUEST:
      return {
        ...state,
        isFetchingAppraisersCoverage: action.isFetchingAppraisersCoverage,
        errorMessage: '',
      }
    case GET_APPRAISERS_COVERAGE_SUCCESS:
      return {
        ...state,
        isFetchingAppraisersCoverage: action.isFetchingAppraisersCoverage,
        currentIndividualCoverageArea: action.currentIndividualCoverageArea,
        currentIndividualCoverageLevel: action.currentIndividualCoverageLevel,
      }
    case GET_APPRAISERS_COVERAGE_FAILURE:
      return {
        ...state,
        isFetchingAppraisersCoverage: action.isFetchingAppraisersCoverage,
        errorMessage: action.message,
      }
    case UPDATE_APPRAISER_COVERAGE_SUCCESS:
      return {
        ...state,
        isUpdatingAppraiserCoverage: action.isUpdatingAppraiserCoverage,
        status: action.status,
      }
    case UPDATE_APPRAISER_COVERAGE_REQUEST:
      return {
        ...state,
        isUpdatingAppraiserCoverage: action.isUpdatingAppraiserCoverage,
        errorMessage: '',
        status: action.status,
      }
    case UPDATE_APPRAISER_COVERAGE_FAILURE:
      return {
        ...state,
        isUpdatingAppraiserCoverage: action.isUpdatingAppraiserCoverage,
        errorMessage: action.message,
        status: action.status,
      }
    case UPDATE_USER_COMPANY_ROLE_REQUEST:
      return {
        ...state,
        isUpdatingCompanyUser: action.isUpdatingCompanyUser,
        errorMessage: '',
      }
    case UPDATE_USER_COMPANY_ROLE_SUCCESS:
      return {
        ...state,
        isUpdatingCompanyUser: action.isUpdatingCompanyUser,
        currentUser: {
          ...state.currentUser,
          company: action.company,
        },
      }
    case UPDATE_USER_COMPANY_ROLE_FAILURE:
      return {
        ...state,
        isUpdatingCompanyUser: action.isUpdatingCompanyUser,
        errorMessage: action.message,
      }
    case REMOVE_USER_FROM_COMPANY_REQUEST:
      return {
        ...state,
        isRemovingUserFromCompany: action.isRemovingUserFromCompany,
        errorMessage: '',
      }
    case REMOVE_USER_FROM_COMPANY_SUCCESS:
      return {
        ...state,
        isRemovingUserFromCompany: action.isRemovingUserFromCompany,
        currentUser: {
          ...state.currentUser,
          company: action.company,
        },
      }
    case REMOVE_USER_FROM_COMPANY_FAILURE:
      return {
        ...state,
        isRemovingUserFromCompany: action.isRemovingUserFromCompany,
        errorMessage: action.message,
      }
    case GET_COMPANY_APPRAISERS_REQUEST:
      return {
        ...state,
        isFetchingCompanyAppraisers: action.isFetchingCompanyAppraisers,
      }
    case GET_COMPANY_APPRAISERS_SUCCESS:
      return {
        ...state,
        isFetchingCompanyAppraisers: action.isFetchingCompanyAppraisers,
        companyAppraisers: action.companyAppraisers,
        companyAppraisersCount: action.companyAppraisersCount,
      }
    case GET_COMPANY_APPRAISERS_FAILURE:
      return {
        ...state,
        isFetchingCompanyAppraisers: action.isFetchingCompanyAppraisers,
        errorMessage: action.message,
      }
    case UPDATE_COMPANY_CLIENT_REQUEST:
      return {
        ...state,
        isUpdatingClient: action.isUpdatingClient,
        errorMessage: '',
      }
    case UPDATE_COMPANY_CLIENT_SUCCESS:
      return {
        ...state,
        isUpdatingClient: action.isUpdatingClient,
        currentUser: { ...state.currentUser, ...action.currentUser },
      }
    case UPDATE_COMPANY_CLIENT_FAILURE:
      return {
        ...state,
        isUpdatingClient: action.isUpdatingClient,
        errorMessage: action.message,
      }
    case CREATE_COMPANY_CLIENT_REQUEST:
      return {
        ...state,
        isCreatingCompanyClient: action.isCreatingCompanyClient,
      }
    case CREATE_COMPANY_CLIENT_SUCCESS:
      return {
        ...state,
        isCreatingCompanyClient: action.isCreatingCompanyClient,
        currentUser: action.currentUser,
      }
    case CREATE_COMPANY_CLIENT_FAILURE:
      return {
        ...state,
        isCreatingCompanyClient: action.isCreatingCompanyClient,
        errorMessage: action.message,
      }
    case EDIT_COMPANY_CLIENT_TAGS_REQUEST:
      return {
        ...state,
        isUpdatingClient: action.isCreatingClient,
        errorMessage: '',
      }
    case EDIT_COMPANY_CLIENT_TAGS_SUCCESS: {
      const cur_user = { ...state.currentUser }
      return {
        ...state,
        currentUser: cur_user,
        isUpdatingClient: action.isCreatingClient,
      }
    }
    case EDIT_COMPANY_CLIENT_TAGS_FAILURE:
      return {
        ...state,
        isUpdatingClient: action.isCreatingClient,
        errorMessage: action.message,
      }
    case VERIFY_INVITATION_EMAILS_REQUEST:
      return {
        ...state,
        isVerifyingEmails: action.isVerifyingEmails,
        verifyEmailSuccess: false,
      }
    case VERIFY_INVITATION_EMAILS_SUCCESS:
      return {
        ...state,
        isVerifyingEmails: action.isVerifyingEmails,
        verifyEmailSuccess: true,
      }
    case VERIFY_INVITATION_EMAILS_FAILURE:
      return {
        ...state,
        isVerifyingEmails: action.isVerifyingEmails,
        errorMessage: action.message,
        verifyEmailSuccess: false,
      }
    case SUBMIT_UPDATED_CONSENT_REQUEST:
      return {
        ...state,
        isSubmittingConsent: action.isSubmittingConsent,
      }
    case SUBMIT_UPDATED_CONSENT_SUCCESS:
      return {
        ...state,
        isSubmittingConsent: action.isSubmittingConsent,
      }
    case SUBMIT_UPDATED_CONSENT_FAILURE:
      return {
        ...state,
        isSubmittingConsent: action.isSubmittingConsent,
        errorMessage: action.message,
      }
    case VERIFY_APPRAISER_REQUEST:
      return {
        ...state,
        isVerifyingAppraiser: action.isVerifyingAppraiser,
      }
    case VERIFY_APPRAISER_SUCCESS:
      return {
        ...state,
        isVerifyingAppraiser: action.isVerifyingAppraiser,
        companyAppraisers: action.companyAppraisers,
      }
    case VERIFY_APPRAISER_FAILURE:
      return {
        ...state,
        isVerifyingAppraiser: action.isVerifyingAppraiser,
        errorMessage: action.message,
      }
    case GET_COMPANY_SUCCESS:
      return {
        ...state,
        currentUser: { ...state.currentUser, company: { ...state.currentUser.company, ...action.company } },
      }
    default:
      return state
  }
}

export default currentUserReducer
